import React, { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode"; // Corrected import for jwt-decode
import Cookies from "js-cookie"; // Import the js-cookie library
import Loading from "../components/Loading";
import { toast } from "react-toastify";

import {
  fetchAllAgents,
  fetchAllVehicles,
} from "../services/api";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // *********** Login User ***********
  const [loginUser, setLoginUser] = useState(null);
  const [loginLoading, setLoginLoading] = useState(true); // To show loading until we verify the token

  // *********** Vehicle Data  ***********
  const [allVehicles, setAllVehicles] = useState([]); // Initialize as empty array instead of undefined
  const [allVehiclesLoading, setAllVehiclesLoading] = useState(false);
  const [allVehiclesError, setAllVehiclesError] = useState(null);

  // Add these missing agent state variables:
  const [allAgents, setAllAgents] = useState([]);
  const [allAgentsLoading, setAllAgentsLoading] = useState(false);
  const [allAgentsError, setAllAgentsError] = useState(null);

  // Check for token and user data in cookies when the component mounts
  useEffect(() => {
    const token = Cookies.get("token");

    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Current time in seconds

        // Check if token is expired
        if (decodedToken.exp < currentTime) {
          logout(); // Token is expired, log out the user
        } else {
          setLoginUser(decodedToken); // Set user info from the decoded token
        }
      } catch (error) {
        console.error("Invalid token", error);
        logout(); // Logout in case of invalid token
      }
    }
    setLoginLoading(false); // Set loading to false after the check is complete
  }, []);

  // ***************** Login *****************
  const login = (token) => {
    Cookies.set("token", token, { expires: 7 }); // Set the token in cookies with an expiration of 7 days

    try {
      const decodedToken = jwtDecode(token);
      console.log("Decoded Token:", decodedToken);
      setLoginUser(decodedToken);
      console.log(decodedToken);
    } catch (error) {
      console.error("Invalid token provided during login", error);
    }
  };

  // ***************** Logout *****************
  const logout = () => {
    Cookies.remove("token"); // Remove the token from cookies
    setLoginUser(null);
  };

  // ***************** function to fetch all vehical data *****************
  const getAllVehicles = async () => {
    setAllVehiclesLoading(true);
    setAllVehiclesError(null);
    try {
      const response = await fetchAllVehicles(); // Call the API function
      // Make sure you're setting the actual array data, not the whole response object
      if (response.success && Array.isArray(response.data)) {
        setAllVehicles(response.data);
      } else {
        setAllVehicles([]); // Fallback to empty array
      }
    } catch (errorMessage) {
      setAllVehiclesError(errorMessage);
      setAllVehicles([]); // Set to empty array on error
      toast.error(errorMessage, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "dark",
      });
    } finally {
      setAllVehiclesLoading(false);
    }
  };

  // ***************** function to fetch all agent data *****************
  const getAllAgents = async () => {
    console.log("Get all Agent Function called from Context");

    setAllAgentsLoading(true);
    setAllAgentsError(null);
    try {
      const response = await fetchAllAgents(); // Call the API function
      setAllAgents(response.data);

      console.log("getAllAgent Data: ", response)

    } catch (errorMessage) {
      setAllAgentsError(errorMessage);
      setAllAgents([]); // Set to empty array on error
      toast.error(errorMessage, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        theme: "dark",
      });
    } finally {
      setAllAgentsLoading(false);
    }
  };


  if (loginLoading) {
    return <Loading />; // Render a loading state until token is checked
  }

  return (
    <AuthContext.Provider
      value={{
        loginUser,
        login,
        logout,



        getAllVehicles,
        allVehicles,
        allVehiclesLoading,
        allVehiclesError,

        getAllAgents,
        allAgents,
        allAgentsLoading,
        allAgentsError,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
